import script from "./Alumnos.vue?vue&type=script&setup=true&lang=js"
export * from "./Alumnos.vue?vue&type=script&setup=true&lang=js"

import "./Alumnos.vue?vue&type=style&index=0&id=5106fca9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5106fca9"]])

export default __exports__